import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Restores scroll to top when the pathname changes.
// Fixes the "new page opens at the previous scroll position" bug.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
